import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield, ChevronRight } from 'lucide-react';
import './Terms.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="terms-page">
      <header className="terms-header">
        <button className="terms-back-btn" onClick={() => navigate(-1)}>
          <ArrowLeft size={24} />
        </button>
        <h1 className="terms-title">Politique de confidentialité</h1>
        <p className="terms-intro">
          Millix s'engage à protéger vos données personnelles et à respecter une politique claire en matière 
          de métadonnées. Dernière mise à jour.
        </p>
      </header>

      <main className="terms-content">
        <section className="terms-level-card">
          <h2 className="terms-level-name" style={{ color: '#0544cc' }}>Données collectées</h2>
          <p className="terms-desc">
            Nous collectons les informations que vous nous fournissez lors de l'inscription : nom, email, 
            numéro de téléphone, et les données liées à votre programme de fidélité (points, historique 
            de transactions, récompenses échangées).
          </p>
        </section>

        <section className="terms-level-card">
          <h2 className="terms-level-name" style={{ color: '#0544cc' }}>Utilisation des données</h2>
          <p className="terms-desc">
            Vos données sont utilisées pour gérer votre compte, calculer vos points Millix, vous proposer 
            des récompenses personnalisées, et vous envoyer des offres adaptées. Nous ne vendons pas 
            vos données à des tiers.
          </p>
        </section>

        <section className="terms-level-card">
          <h2 className="terms-level-name" style={{ color: '#0544cc' }}>Sécurité</h2>
          <p className="terms-desc">
            Vos données sont protégées par des mesures de sécurité appropriées. Les mots de passe sont 
            chiffrés. L'accès aux données personnelles est limité aux personnes autorisées.
          </p>
        </section>

        <section className="terms-level-card">
          <h2 className="terms-level-name" style={{ color: '#0544cc' }}>Vos droits</h2>
          <p className="terms-desc">
            Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression 
            et de portabilité de vos données. Vous pouvez exercer ces droits en nous contactant ou 
            depuis votre espace compte.
          </p>
        </section>

        <section className="terms-level-card">
          <h2 className="terms-level-name" style={{ color: '#0544cc' }}>Métadonnées</h2>
          <p className="terms-desc">
            Conformément à notre politique relative aux métadonnées, nous pouvons collecter et traiter des 
            métadonnées techniques liées à votre utilisation du service : date et heure des transactions, 
            lieu (magasin/point de vente), identifiant des opérations (numéro de facture, code QR), et 
            données techniques nécessaires au bon fonctionnement et à la sécurité du programme de fidélité. 
            Ces métadonnées sont utilisées uniquement pour le calcul des points, la traçabilité des 
            opérations, la prévention des abus et le support client. Elles ne sont pas vendues à des tiers 
            et sont conservées selon les mêmes durées que les données associées.
          </p>
        </section>

        <section className="terms-level-card">
          <h2 className="terms-level-name" style={{ color: '#0544cc' }}>Cookies et traceurs</h2>
          <p className="terms-desc">
            L'application peut utiliser des cookies ou technologies similaires pour le bon fonctionnement 
            du service, l'authentification et la mémorisation de vos préférences.
          </p>
        </section>

        <section className="terms-level-card">
          <h2 className="terms-level-name" style={{ color: '#0544cc' }}>Contact</h2>
          <p className="terms-desc">
            Pour toute question relative à la confidentialité ou pour exercer vos droits, contactez-nous 
            via le Centre d'aide dans l'application ou par email à l'adresse indiquée sur notre site.
          </p>
        </section>
      </main>

      <footer className="terms-footer">
        <Link to="/terms" className="terms-link">
          Consulter les Règles Millix
          <ChevronRight size={18} />
        </Link>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
